import React from 'react';
import PropTypes from 'prop-types';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import useTimeZone from './useTimeZone';

const TimezoneFilter = ({ value, setFilters }) => {
  const { timeZoneOptions, onSubmit, formSchema } = useTimeZone({ setFilters });
  return (
    <Formik
      initialValues={{ tzAbbreviation: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="tzAbbreviation"
          label="Timezone"
          placeholder="Select timezone"
          size="small"
          component={FormMultiSelect}
          options={timeZoneOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

TimezoneFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

TimezoneFilter.defaultProps = {
  value: [],
};

export default TimezoneFilter;
